

















































import { Inject, Component, Vue } from 'vue-property-decorator'
import { WinckCollection, WinckScheduledCollection, WinckScreen } from '@/api/client/winck-proxy'
import Info from '@/views/Company/Settings/Narrowcasting/Info.vue'
import moment from 'moment'
import { namespace } from 'vuex-class'
const narrowcasting = namespace('narrowcasting')

@Component({
    components: {
        Info,
    },
})
export default class CompanySettingsNarrowcastingScheduledCollectionsList extends Vue {
    @Inject() readonly navigateToCreate: () => Promise<void>
    @Inject() readonly navigateToEdit: (scheduledCollectionId: string) => Promise<void>
    @narrowcasting.State readonly scheduledCollections!: WinckScheduledCollection[]
    @narrowcasting.State readonly screens!: WinckScreen[]
    @narrowcasting.State readonly collections!: WinckCollection[]
    @narrowcasting.Action readonly deleteScheduledCollection: (scheduledCollection: WinckScheduledCollection) => Promise<void>

    async editItem(scheduledCollection: WinckScheduledCollection): Promise<void> {
        await this.navigateToEdit(scheduledCollection.id)
    }

    async deleteItem(scheduledCollection: WinckScheduledCollection): Promise<void> {
        if (confirm(this.$t('narrowcasting.scheduledCollection.list.delete').toString())) {
            await this.deleteScheduledCollection(scheduledCollection)
        }
    }

    convertDate(date: string): string {
        return moment(date).format('LL')
    }

    convertDay(dayOfWeek: number): string {
        switch (dayOfWeek) {
            case 0: return this.$t('narrowcasting.scheduledCollection.list.day.0').toString()
            case 1: return this.$t('narrowcasting.scheduledCollection.list.day.1').toString()
            case 2: return this.$t('narrowcasting.scheduledCollection.list.day.2').toString()
            case 3: return this.$t('narrowcasting.scheduledCollection.list.day.3').toString()
            case 4: return this.$t('narrowcasting.scheduledCollection.list.day.4').toString()
            case 5: return this.$t('narrowcasting.scheduledCollection.list.day.5').toString()
            case 6: return this.$t('narrowcasting.scheduledCollection.list.day.6').toString()
            default: return 'Altijd actief'
        }
    }
}
